import { render, staticRenderFns } from "./tokenList.vue?vue&type=template&id=487f95c0&scoped=true&"
import script from "./tokenList.vue?vue&type=script&lang=js&"
export * from "./tokenList.vue?vue&type=script&lang=js&"
import style0 from "./tokenList.vue?vue&type=style&index=0&id=487f95c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f95c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487f95c0')) {
      api.createRecord('487f95c0', component.options)
    } else {
      api.reload('487f95c0', component.options)
    }
    module.hot.accept("./tokenList.vue?vue&type=template&id=487f95c0&scoped=true&", function () {
      api.rerender('487f95c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/mintage/tokenList.vue"
export default component.exports